import { Row } from 'react-bootstrap';
// import React, { useState, useEffect } from 'react';
import { Navbar } from '../navbar/navbar';
import Styles from './home.module.scss';
import { InfoSection } from '../healthandprecautions/infoSection';
import { DashboardSection } from '../dashboard/dashboard';
import { AboutUs } from '../aboutus/aboutus';
import { ContactUs } from '../contactus/contactus';
import { Footer} from '../footer/footer';
import { Map } from '../map/map.jsx';


function Home() {
	return (
		<div className={Styles.home}>
			<Row>
				<Navbar/>
				<Map/>
				<DashboardSection/>
				<InfoSection/>
				<AboutUs/>
				<ContactUs/>
				<Footer/>
			</Row>
		</div>
	);
}

export { Home };
